import React from 'react';

// Components
import Typography from '../Typography';

// Styles
import styles from './style.module.scss';

interface TextInputProps {
  label?: string;
  helper?: string;
  value: string;
  required?: boolean;
  type?: 'text' | 'password' | 'email' | 'number' | 'tel' | 'url' | 'search' | 'date' | 'time' | 'datetime-local' | 'month' | 'week';
  onChange?: (value: string) => void;
  error?: string | null;
  adornmentRight?: React.ReactNode;
  adornmentLeft?: React.ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  classes?: {
    root?: string;
    label?: string;
    input?: string;
    error?: string;
    helper?: string;
  };
  onClick?: () => void;
}

const TextInput: React.FC<TextInputProps> = ({
  label, helper, value, required, type, onChange, error, adornmentRight, adornmentLeft, disabled, readOnly, classes, onClick, ...props }) => {
  return (
    <div className={`${styles.root} ${classes?.root}`}>
      {label && (
        <label htmlFor={label} className={`${styles.label} ${classes?.label}`}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}

      <div className={styles.input_container}>
        <div className={styles.adornment_left}>
          {adornmentLeft}
        </div>

        {readOnly
          ? (
            <Typography
              className={`${styles.input} ${classes?.input}`}
              variant='p'
            >
              {value}
            </Typography>
          )
          : (
            <input
              type={type}
              value={value}
              onChange={(e) => onChange?.(e.target.value)}
              className={`${styles.input} ${classes?.input}`}
              disabled={disabled}
              readOnly={readOnly}
              onClick={onClick ? onClick : undefined}
            />
          )
        }


        <div className={styles.adornment_right}>
          {adornmentRight}
        </div>
      </div>

      {error && <p className={`${styles.error} ${classes?.error}`}>{error}</p>}
      {helper && !error && <p className={`${styles.helper} ${classes?.helper}`}>{helper}</p>}
    </div>
  )
};

export default TextInput;
